import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'angular-bootstrap-md';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Family } from 'src/app/models/Family';
import { ReportOrder } from 'src/app/models/ReportOrder';
import { SearchReport } from 'src/app/models/SearchReport';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { FamilyService } from 'src/app/services/family.service';
import { ReportService } from 'src/app/services/report.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';

declare var jQuery: any;

@Component({
  selector: 'app-order-tracking-report',
  templateUrl: './order-tracking-report.component.html',
  styleUrls: ['./order-tracking-report.component.scss']
})
export class OrderTrackingReportComponent implements OnInit {
  @ViewChild('filtro') filtro: ModalDirective;

  public families: Family[] = [];
  public familySelected: string;
  public itemAnteriorI: number;
  public itemAnteriorD: string;
  public codeAnterior: string;
  public itemSelected: string;
  public reportOrder: ReportOrder;

  constructor(private spinner: NgxSpinnerService, private reportService: ReportService, 
    private toastr: ToastrService, private router: Router, private familyService: FamilyService,
    private authService: AuthenticationService) { }

  ngOnInit() {
    this.spinner.show();
    try{
      jQuery.getScript(CONSTANTES.menu);
    } catch(Error){
      this.router.navigate(['login']);
    }
    this.loadFamilies();
  }

  // Carga las familias
  loadFamilies(){
    this.familyService.getAll().subscribe(
      data => {
        if (getToken(data)){
          for (let i = 0; i < data.families.length; i++) {
            if (data.families[i].parent === null) {
              this.families.push(data.families[i]);              
            }
          }
        } else {
          this.toastr.warning(data.errorCode.message, "ERROR");
        }
        this.spinner.hide();        
      }, error => {
        this.toastr.error(error);
        this.logOut();
      }
    )
  }

  // Se filtran los articulos y se muestran
  getFamilyFilter(family: any, d: string, i: number) {
    this.spinner.show();
    this.familySelected = family.name;
    let item = <HTMLInputElement>document.getElementById("item" + d + family.code + i);

    this.itemSelected = item.nextSibling.textContent;

    item.checked = true;
    // aqui se controla que se desmarque el checkbox del anterior marcado
    if (this.itemAnteriorD != undefined && this.itemAnteriorI != undefined && this.codeAnterior != undefined) {
      let itemAnterior = <HTMLInputElement>document.getElementById("item" + this.itemAnteriorD + this.codeAnterior + this.itemAnteriorI);
      if (this.itemAnteriorI === i && this.itemAnteriorD === d && this.codeAnterior === family.code)
        itemAnterior.checked = true;
      else
        itemAnterior.checked = false;
    }

    this.itemAnteriorI = i;
    this.itemAnteriorD = d;
    this.codeAnterior = family.code;

    this.getOrders(family);
    
  }

  getOrders(family: Family){
    let searchReport: SearchReport = new SearchReport();
    searchReport.nid = localStorage.getItem("nid");
    searchReport.family = family.code;

    let reportData: ReportOrder = new ReportOrder();
    reportData.searchReport = searchReport; 
    this.reportService.getReportTrackingOrders(reportData).subscribe(
      data => {
        if (getToken(data)){
          this.reportOrder = data;
          if (this.reportOrder.orders === undefined || this.reportOrder.orders === null || this.reportOrder.orders.length === 0){
            this.toastr.info("NO EXISTEN PEDIDOS DEL EQUIPO SELECCIONADO", "INFO");
          }
        } else {
          this.toastr.warning(data.errorCode.message, "ERROR");
        }
        this.filtro.hide();
        this.spinner.hide();
      }, error => {
        this.toastr.error("ERROR AL OBTENER LOS PEDIDOS", "ERROR");
        this.logOut();
      }
    );
  }

  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['login']);
      }
    );
  }

}
